import axios from '../api/axiosInstance';

export const fetchProducts = (params) => {
  return axios.get('/products', { params });
};

export const createProduct = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === 'image') {
      if (data.image) formData.append('image', data.image);
    } else if (Array.isArray(data[key])) {
      formData.append(key, JSON.stringify(data[key]));
    } else {
      formData.append(key, data[key]);
    }
  });
  return axios.post('/products', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateProduct = (id, data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === 'image') {
      if (data.image) formData.append('image', data.image);
    } else if (Array.isArray(data[key])) {
      formData.append(key, JSON.stringify(data[key]));
    } else {
      formData.append(key, data[key]);
    }
  });
  return axios.put(`/products/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
